<template>
<div class="target b-white rounded shadow-sm py-5" id="cv-template">
    <div class="container py-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="_header text-center">
                        <div class="_profile">
                                <img :src="user.avatar" alt="" class="shadow-lg rounded-circle" width="100" height="100">
                                <div class="_name my-3">
                                    <h4 class="m-0">
                                        <i class="fas fa-globe-americas" v-if="user.public"></i>
                                        <i class="fas fa-lock" v-if="!user.public"></i>
                                        {{user.name + ' ' + user.lname}}</h4>
                                    <small>Ultima actualización: {{ user.updated_at | timeDate }}</small>
                                </div>
                                <div class="_location" v-if="user.student_info && user.student_info.location">
                                    Ubicación <br>
                                    <i class="fas fa-location-arrow"></i> {{user.student_info.location}}
                                </div>
                                <div class="isContacted" v-if="contacted">
                                    <br>
                                    <div class="_phone font-green" v-if="user.student_info && user.student_info.phone">
                                        Teléfono de contacto<br>
                                        <i class="fas fa-phone"></i> {{user.student_info.phone}}
                                    </div>
                                    <br>
                                    <div class="_mail font-green" v-if="user && user.email">
                                        Dirección de correo<br>
                                        <i class="fas fa-envelope"></i> {{user.email}}
                                    </div>
                                </div>
                                <div v-else class="py-3 font-gray-dark">
                                    <h2 class="fas fa-lock"></h2>
                                    <h5>Información oculta</h5>
                                    <div>
                                        Para visualizar la información de este usuario, es requerido que <br>
                                        inicies un proceso de contacto
                                    </div>
                                </div>
                                <br>
                                <div class="_birtday" v-if="user.student_info && user.student_info.birthday">
                                    Fecha de nacimiento <br>
                                    {{user.student_info.birthday}}
                                </div>
                                <br>
                                <div class="_biography" v-if="user.student_info && user.student_info.biography">
                                    Biografía <br>
                                    {{user.student_info.biography}}
                                </div>
                        </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-lg-6 text-right">
                <div class="_education my-3" v-if="user.education && user.education.length > 0">
                    <h4 class="font-weight-light"> Educación</h4>
                    <ul class="list-unstyled">
                        <li v-for="(item, key) in user.education" :key="key">
                            {{item.institucion}}
                            <ol>{{item.titulo}}</ol>
                            <ol>{{item.grado}}</ol>
                            <ol>{{item.ano_inicio + ' - ' + item.ano_fin}}</ol>
                            <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>
                        </li>
                    </ul>
                </div>
                <div class="_skill my-3" v-if="user.skill && user.skill.length > 0">
                    <h4 class="font-weight-light"> Habilidades</h4>
                    <li class="list-unstyled" v-for="(item, key) in user.skill" :key="key">
                        {{item.habilidad}}
                        <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>
                    </li>
                </div>
                <div class="_software my-3" v-if="user.software && user.software.length > 0">
                    <h4 class="font-weight-light"> Software</h4>
                    <li class="list-unstyled" v-for="(item, key) in user.software" :key="key">
                        {{item.software}}
                        <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>
                        </li>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="_experience my-3" v-if="user.experience && user.experience.length > 0">
                    <h4 class="font-weight-light">  Experiencia Laboral</h4>
                        <ul class="list-unstyled">
                        <li v-for="(item, key) in user.experience" :key="key">
                            {{item.puesto}}
                            <ol>{{item.empresa}}</ol>
                            <ol>Area {{item.area}}</ol>
                            <ol>{{item.descripcion}}</ol>
                        </li>
                    </ul>
                </div>
                <div class="_project my-3" v-if="user.project && user.project.length > 0">
                        <h4 class="font-weight-light"> Proyectos y publicaciones</h4>
                        <ul class="list-unstyled">
                        <li v-for="(item, key) in user.project" :key="key">
                            {{item.nombre}}
                            <ol>{{item.empresa}}</ol>
                            <ol>Tipo {{item.tipo}}</ol>
                            <ol>Emisor {{item.emisor}}</ol>
                            <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>
                        </li>
                    </ul>
                </div>
                <div class="_achievement my-3" v-if="user.achievement && user.achievement.length > 0">
                        <h4 class="font-weight-light"> Logros y reconocimientos</h4>
                        <ul class="list-unstyled">
                        <li v-for="(item, key) in user.achievement" :key="key">
                            {{item.nombre}}
                            <ol>{{item.empresa}}</ol>
                            <ol>Función {{item.funcion_desempenada}}</ol>
                            <ol>Tipo {{item.tipo}}</ol>
                            <ol>{{item.mes + ' - ' + item.ano_fin}}</ol>
                            <ol>{{item.descripcion}}</ol>
                            <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>
                        </li>
                    </ul>
                </div>
                <div class="_service" v-if="user.service && user.service.length > 0">
                        <h4 class="font-weight-light">Servicio y voluntariado</h4>
                        <ul class="list-unstyled">
                        <li v-for="(item, key) in user.service" :key="key">
                            {{item.organizacion}}
                            <ol>{{item.empresa}}</ol>
                            <ol>Función {{item.funcion_desempenada}}</ol>
                            <ol>{{item.ano_inicio + ' - ' + item.ano_fin}}</ol>
                            <ol>{{item.descripcion}}</ol>
                            <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>

</style>
<script>
export default {
    props:{
        user: Object,
        contacted: {
           type: Boolean,
           default: false
        }
    },
    methods: {

    },
    created() {

    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/candidates_gold/components/CandidateCV.vue